function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cs_svg__cls-1{fill:#f0f0f0}.cs_svg__cls-2{fill:#e91e26}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "cs_svg__cls-1",
  d: "M.4 7.2c-.1.2-.1.5-.2.7a1.45 1.45 0 01.2-.7zM.1 8.4a4.33 4.33 0 01-.1.5.9.9 0 00.1-.5zM10 0a9.7 9.7 0 00-8.81 5.1 9.12 9.12 0 011.7-2.3l7.16 7.2H20A9.84 9.84 0 0010 0zM.7 6.1c-.1.3-.2.5-.3.8a6.89 6.89 0 01.3-.8z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cs_svg__cls-1",
  d: "M1.19 5.1c-.1.3-.29.5-.39.8a7 7 0 01.39-.8z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cs_svg__cls-2",
  d: "M2.89 17.1a9.12 9.12 0 01-1.7-2.3 19.52 19.52 0 001.7 2.3z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cs_svg__cls-2",
  d: "M10 10l-7.11 7.1A9.87 9.87 0 0010 20a10 10 0 0010-10zM1.19 14.8A15.64 15.64 0 01.4 13a15.64 15.64 0 00.79 1.8z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M2.79 2.8A9.67 9.67 0 000 10a10 10 0 002.89 7.1L10 10z",
  fill: "#005aa7"
});

function SvgCs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cs_svg__Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZjBmMGYwO30uY2xzLTJ7ZmlsbDojZTkxZTI2O30uY2xzLTN7ZmlsbDojMDA1YWE3O308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0uNCw3LjJjLS4xLjItLjEuNS0uMi43QTEuNDUsMS40NSwwLDAsMSwuNCw3LjJaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNLjEsOC40YTQuMzMsNC4zMywwLDAsMS0uMS41QS45LjksMCwwLDAsLjEsOC40WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTEwLDBBOS43LDkuNywwLDAsMCwxLjE5LDUuMWE5LjEyLDkuMTIsMCwwLDEsMS43LTIuM0wxMC4wNSwxMEgyMEE5Ljg0LDkuODQsMCwwLDAsMTAsMFoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0uNyw2LjFjLS4xLjMtLjIuNS0uMy44QTYuODksNi44OSwwLDAsMSwuNyw2LjFaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMS4xOSw1LjFjLS4xLjMtLjI5LjUtLjM5LjhBNyw3LDAsMCwxLDEuMTksNS4xWiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTIuODksMTcuMWE5LjEyLDkuMTIsMCwwLDEtMS43LTIuM0ExOS41MiwxOS41MiwwLDAsMCwyLjg5LDE3LjFaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTAsMTAsMi44OSwxNy4xQTkuODcsOS44NywwLDAsMCwxMCwyMGExMCwxMCwwLDAsMCwxMC0xMFoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xLjE5LDE0LjhBMTUuNjQsMTUuNjQsMCwwLDEsLjQsMTMsMTUuNjQsMTUuNjQsMCwwLDAsMS4xOSwxNC44WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTIuNzksMi44QTkuNjcsOS42NywwLDAsMCwwLDEwYTEwLDEwLDAsMCwwLDIuODksNy4xTDEwLDEwWiIvPjwvc3ZnPg==";
export { SvgCs as ReactComponent };